<template>
  <div :style="`width:100%;height:${dispH}px;`" class="rise">
    <div style="display: flex; justify-content: space-between; line-height: 30px">
      <span class="span">{{ $t("langcfg.txtRiseArc") }}</span>
      <span class="span">{{ k1e1 }}</span>
      <span class="span">{{ k2e2 }}</span>
      <div style="text-align: right; display: inline-block">
        <span class="span">{{ $t("langcfg.txtDia") }}:</span>
        <el-input-number
          v-model="diaVal"
          @focus="handleClick"
          :precision="2"
          :step="0.2"
          :min="2"
          :max="12"
          @change="onDiaChanged"
        ></el-input-number>
        <span class="span">mm</span>
        <br />
      </div>
    </div>

    <canvas
      id="riseCanvas"
      @mousemove="showValue"
      @click="markValue"
      width="912px"
      :height="`${dispH - 55}px`"
      style="cursor: pointer"
    ></canvas>
  </div>
</template>

<script>
import { isDefined } from "../shared";
import { INVALID_1000 } from "../../shared/consts";
import { draw, clearClicked } from "../js/RiseArchDrawn";
import EVENTS from "../../bus";
import { canConvertNumber } from "../../shared/utils";

export default {
  name: "RGP-RiseArch",
  components: {},
  props: {
    dispH: {
      required: true,
      type: Number
    },
    RgpHelper: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      diaVal: 7,
      chartData: null,
      axisYInfo: { min: 0, max: 0, num: 5 },
      focusX: -1,
      focusY: -1,
      clickX: -1,
      clickY: -1,
      k1e1: "",
      k2e2: ""
    };
  },
  mounted() {
    this.update();
  },
  methods: {
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.diaVal.toString(), (value) => {
        if (canConvertNumber(value)) {
          self.diaVal = Number(value);
        }
      });
    },
    update() {
      this.updateKeccVal();
      this.updateChartData();
      this.initAxisRange();
      this.drawChart();
    },
    onDiaChanged() {
      this.update();
    },
    updateKeccVal() {
      let k1Val, e1Val, k2Val, e2Val;
      k1Val = e1Val = k2Val = e2Val = "--";
      if (!isDefined(this.RgpHelper) || !isDefined(this.RgpHelper.fCalcSFeccK)) {
        return;
      }
      let obj = this.RgpHelper.fCalcSFeccK(this.diaVal);
      if (obj.result !== true) {
        return;
      }
      let flat = obj.flatBuffer;
      let steep = obj.steepBuffer;
      k1Val = `${this.getKeccStr(flat[1], 0)}D@${this.getKeccStr(flat[0], 0)}º`;
      e1Val = this.getKeccStr(flat[2], 1);
      k2Val = `${this.getKeccStr(steep[1], 0)}D@${this.getKeccStr(steep[0], 0)}º`;
      e2Val = this.getKeccStr(steep[2], 1);

      this.k1e1 = `K1: ${k1Val}  e: ${e1Val}`;
      this.k2e2 = `K2: ${k2Val}  e: ${e2Val}`;
    },
    updateChartData() {
      this.chartData = null;
      if (!isDefined(this.RgpHelper) || !isDefined(this.RgpHelper.fCalcRiseArch)) {
        return;
      }
      let obj = this.RgpHelper.fCalcRiseArch(this.diaVal);
      if (obj.result !== true) {
        return false;
      }
      this.chartData = obj.out360;
    },
    getKeccStr(data, decimal) {
      if (data === INVALID_1000) {
        return "--";
      } else {
        return data._toFixed(decimal);
      }
    },
    initAxisRange() {
      let min = 0;
      let max = 5;
      if (isDefined(this.chartData) && this.chartData.length > 0) {
        let tmp = [];
        for (let i = 0; i < this.chartData.length; i++) {
          if (this.chartData[i] === INVALID_1000) continue;
          tmp.push(this.chartData[i]);
        }
        if (tmp.length > 0) {
          min = parseInt(Math.floor(Math.min.apply(null, tmp) * 10));
          max = parseInt(Math.ceil(Math.max.apply(null, tmp) * 10));
          if (max - min < 1) {
            min -= 1;
            max += 1;
          }
        }
      }
      this.axisYInfo.max = max / 10;
      this.axisYInfo.min = min / 10;

      this.clickX = this.clickY = this.focusX = this.focusY = -1;
      clearClicked();
    },
    drawChart() {
      if (!isDefined(this.chartData) || this.chartData.length <= 0) {
        return;
      }
      let element = document.getElementById("riseCanvas");
      let ctx = element.getContext("2d");
      draw(
        element,
        ctx,
        this.chartData,
        this.axisYInfo,
        { x: this.focusX, y: this.focusY },
        { x: this.clickX, y: this.clickY }
      );
      this.focusY = this.focusY = this.clickX = this.clickY = -1;
    },
    showValue(event) {
      if (!event) return;
      this.focusX = event.offsetX;
      this.focusY = event.offsetY;
      this.drawChart();
    },
    markValue(event) {
      if (!event) return;
      this.clickX = event.offsetX;
      this.clickY = event.offsetY;
      this.drawChart();
    }
  },
  watch: {},
  computed: {},
  beforeDestory() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.el-input-number /deep/ .el-input__inner {
  font-size: 20px;
}
.el-input-number /deep/ .el-input-number__increase {
  font-size: 20px;
}
.el-input-number /deep/ .el-input-number__decrease {
  font-size: 20px;
}
.rise {
  .div-val {
    text-align: right;
    .span-eval {
      margin-right: 20px;
    }
  }
  .span {
    font-size: 20px;
    color: #bec0cc;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-RiseArch.vue